import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import {TopButtonAction, TopButtonPointAction, TopButtonPointEdit, TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../../utilities/TabUtilities";
import DateAndTimeFormat from "../../../../../utilities/DateAndTimeFormat";
import {Link} from "react-router-dom";
import LSService from "../../../../../utilities/localStorageService/LSService";
import TrasyTableSelectOdwrotna from "./TrasyTableSelectOdwrotna";

export default class TrasyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.formatStatusy = this.formatStatusy.bind(this)
        this.formatCzySprzedaz = this.formatCzySprzedaz.bind(this)
        this.formatEprzystanki = this.formatEprzystanki.bind(this)
        this.formatStawka = this.formatStawka.bind(this)
        this.renderTrasaOdwrotna = this.renderTrasaOdwrotna.bind(this)
        this.renderNazwaTrasyILinia = this.renderNazwaTrasyILinia.bind(this)
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointAction onClick={() => {
                    this.props.handleClickPokazTraseNaMapie(row)
                }} titleContent={'Pokaż trasę na mapie'} buttonIcon={'fa fa-globe'} buttonColor={'default'} disabled={row.status === -1}/>
                <TopButtonPointEdit onClick={() => {
                    this.props.handleEdytuj(row)
                }} titleContent={'Edytuj trasę'}/>
                <TopButtonPointRemove onClick={() => {
                    this.props.handleUsun(row)
                }} titleContent={'Usuń trasę'}/>
            </div>
        )
    }

    renderKodTrasy(cell, row) {
        return (
            <div>
                <span className={'label label-ebus-primary'}>{cell}</span>
            </div>
        )
    }

    renderCzasTrwania(cell, row) {
        if (cell !== null && cell !== '')
            return DateAndTimeFormat.formatHHMM(cell)
        else return cell
    }

    formatStatusy(cell, row) {

        if (cell == 0) {
            return (
                <div title={'Kliknij aby zmienić status'}>
                    <TopButtonAction block btnColor={'default'} onClick={() => {
                        this.props.handleZmienStatus(row, -1)
                    }} text={'dostępny'} iconType={'fa fa-check'} className={'btn-status-dostepny'}/>
                </div>
            )
        }
        else {
            return (
                <div title={'Kliknij aby zmienić status'}>
                    <TopButtonAction block btnColor={'default'} onClick={() => {
                        this.props.handleZmienStatus(row, 0)
                    }} text={'niedostępny'} iconType={'fa fa-times'} className={'btn-status-niedostepny'}/>
                </div>
            )
        }
    }

    formatEprzystanki(cell, row) {
        return <div style={{textAlign: 'center', lineHeight: '30px'}}>
            <Link to={'/konfiguracja/zarzadzanie-trasami/eprzystanki'} target={'_blank'} onClick={() => {
                LSService.ustawIdTrasyDoEprzystankow(row.idTr);
            }}>
                Zobacz e-przystanki
            </Link></div>
    }

    formatCzySprzedaz(cell, row) {
        if (Boolean(cell)) {
            return (
                <div title={'Kliknij aby zmienić dostęp do sprzedaży'}>
                    <TopButtonAction block btnColor={'default'} onClick={() => {
                        this.props.handleZmienSprzedaz(row, 0)
                    }} text={'możliwa'} iconType={'fa fa-check'} className={'btn-status-dostepny'}/>
                </div>
            )
        }
        else {
            // gdy 0 lub null
            return (
                <div title={'Kliknij aby zmienić dostęp do sprzedaży'}>
                    <TopButtonAction block btnColor={'default'} onClick={() => {
                        this.props.handleZmienSprzedaz(row, 1)
                    }} text={'brak'} iconType={'fa fa-times'} className={'btn-status-niedostepny'}/>
                </div>
            )
        }
    }

    formatStawka(cell, row) {
        return cell
    }

    renderTrasaOdwrotna(cell, row) {
        return <TrasyTableSelectOdwrotna trasy={this.props.data} idTrPow={cell} handleChangeTrasaOdwrotna={(e)=>this.props.handleChangeTrasaOdwrotna(row,e)}/>
    }

    renderNazwaTrasyILinia(cell,row){
        let linia = this.props.linie.find(l=>l.trasaGlownaId==row.idTr || l.trasaPowrotnaId==row.idTr)
        if(Boolean(linia)){
            return (<div>
                <div>{cell}</div>
                <div style={{color:'grey', fontSize:'11px'}}>Linia: {linia.relacja}</div>
            </div>)
        }else return cell
    }

    render() {

        let statusy = {
            0: 'dostępny',
            1: 'niedostępny'
        }

        const options = {
            sizePerPage: 15,
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów'
        };
        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='idTr' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='kodTrasy' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       dataFormat={this.renderKodTrasy}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Kod trasy</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazTr' dataSort
                                       thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.renderNazwaTrasyILinia}
                    >Nazwa trasy</TableHeaderColumn>
                    <TableHeaderColumn dataField='dystans' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Dystans</TableHeaderColumn>
                    <TableHeaderColumn dataField='czasTr' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.renderCzasTrwania}
                    >Czas trwania</TableHeaderColumn>
                    <TableHeaderColumn dataField='stawka' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatStawka}
                    >Stawka</TableHeaderColumn>
                    <TableHeaderColumn dataField='status' dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={{type: 'SelectFilter', options: statusy, selectText: 'Wybierz'}} dataFormat={this.formatStatusy}
                                       formatExtraData={statusy}
                    >Czy dostępna?</TableHeaderColumn>
                    <TableHeaderColumn dataField='idTr' dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatEprzystanki}
                    >e-przystanki</TableHeaderColumn>
                    <TableHeaderColumn dataField='idTrPow' dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.renderTrasaOdwrotna}
                    >Trasa odwrotna</TableHeaderColumn>
                    <TableHeaderColumn dataField='idTr'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunPlusDodatkowaHtml('Zobacz', '#333')}</TableHeaderColumn>

                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/trasy/components/TrasyTable.js